// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3iW0v","header":"Messages_header__EjGXL"};